export default "__VITE_ASSET__CyvmaVl8__"